export default __webpack_public_path__ + "static/media/facebookIcon.e946716d.svg";